import { render } from "./tw-dropdown.vue?vue&type=template&id=5be7c9c1&scoped=true"
import script from "./tw-dropdown.vue?vue&type=script&lang=js"
export * from "./tw-dropdown.vue?vue&type=script&lang=js"

import "./tw-dropdown.vue?vue&type=style&index=0&id=5be7c9c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5be7c9c1"

export default script